/**
 * Text-till-tal-hjälpare för NPF-barnvyns kompanjon.
 *
 * Läser upp kompanjonens pratbubbla via webbläsarens SpeechSynthesis. Lugn,
 * lite ljusare röst (rate 0.95, pitch 1.05) på svenska. Anropas ENDAST vid tap
 * på avataren — aldrig automatiskt — för att undvika överstimulering.
 *
 * Graceful fallback: saknar webbläsaren SpeechSynthesis (eller körs utanför
 * browser, t.ex. i test/SSR) returneras false utan att kasta. Anroparen kör då
 * sin visuella re-animation ändå, så tap-affordansen alltid ger feedback.
 */
export const speak = (text: string): boolean => {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) {
    return false;
  }

  const trimmed = text.trim();
  if (trimmed.length === 0) {
    return false;
  }

  try {
    const synth = window.speechSynthesis;
    // Avbryt pågående uppläsning så snabba upprepade tap inte köar upp sig.
    synth.cancel();
    const utterance = new SpeechSynthesisUtterance(trimmed);
    utterance.lang = 'sv-SE';
    utterance.rate = 0.95;
    utterance.pitch = 1.05;
    utterance.volume = 1;
    synth.speak(utterance);
    return true;
  } catch {
    // Vissa miljöer exponerar speechSynthesis men kastar vid speak() — svälj
    // tyst, anroparen faller tillbaka på enbart re-animation.
    return false;
  }
};
